package one.healthium.ui.common.utils

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import one.healthium.domain.common.ImageMode
import one.healthium.domain.common.Insets
import one.healthium.domain.common.Shimmering
import one.healthium.ui.compose.components.AppShimmerConfig

@Composable
fun one.healthium.domain.common.Color.toColor(): Color? {
    val colorValue = if (isSystemInDarkTheme()) this.dark else this.light
    return colorValue?.let { Color(it) }
}

@Composable
fun one.healthium.domain.common.TextStyle?.toTextStyle(fallback: TextStyle): TextStyle {
    return if (this == null) {
        fallback
    } else {
        fallback.copy(
            color = this.color?.toColor() ?: fallback.color,
            fontWeight = this.fontWeight.toFontWeight() ?: fallback.fontWeight,
            fontSize = this.fontSize?.sp ?: fallback.fontSize,
            textAlign = when (this.alignment) {
                "left" -> TextAlign.Start
                "center" -> TextAlign.Center
                "right" -> TextAlign.End
                else -> fallback.textAlign
            }
        )
    }
}

fun String?.toFontWeight(): FontWeight? {
    return when (this?.lowercase()) {
        "regular" -> FontWeight.Normal
        "medium" -> FontWeight.Medium
        "semibold" -> FontWeight.SemiBold
        "bold" -> FontWeight.Bold
        else -> null
    }
}

fun String?.toFontStyle(): FontStyle? {
    return when (this?.lowercase()) {
        "italic" -> FontStyle.Italic
        else -> null
    }
}

fun ImageMode.toContentScale() = when (this) {
    ImageMode.Fit -> ContentScale.Fit
    ImageMode.Crop -> ContentScale.Crop
}

fun String?.toTextAlign(): TextAlign? {
    return when (this) {
        "left" -> TextAlign.Start
        "center" -> TextAlign.Center
        else -> null
    }
}

fun String?.toAlignmentHorizontal(): Alignment.Horizontal? {
    return when (this) {
        "left" -> Alignment.Start
        "center" -> Alignment.CenterHorizontally
        "right" -> Alignment.End
        else -> null
    }
}

fun Insets?.toPaddingValues() = if (this != null) {
    PaddingValues(
        start = left.dp,
        top = top.dp,
        end = right.dp,
        bottom = bottom.dp,
    )
} else {
    PaddingValues()
}

fun Insets?.toPaddingValuesHorizontal() = if (this != null) {
    PaddingValues(
        start = left.dp,
        end = right.dp,
    )
} else {
    PaddingValues()
}

@Composable
fun Shimmering.toShimmeringConfig() = AppShimmerConfig(
    color = color.toColor() ?: Color.White,
    duration = duration,
    interval = interval,
)